import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_PRE_REGISTRATION_CONFIGURATIONS, 
    ADD_NEW_PRE_REGISTRATION_CONFIGURATION, 
    UPDATE_PRE_REGISTRATION_CONFIGURATION, 
    DELETE_PRE_REGISTRATION_CONFIGURATION 
} from "./actionTypes";
import {
    getPreRegistrationConfigurationsSuccess,
    getPreRegistrationConfigurationsFail,
    addPreRegistrationConfigurationSuccess,
    addPreRegistrationConfigurationFail,
    updatePreRegistrationConfigurationSuccess,
    updatePreRegistrationConfigurationFail,
    deletePreRegistrationConfigurationSuccess,
    deletePreRegistrationConfigurationFail,
   
} from "./actions"

import {
    getPreRegistrationConfigurations,
    addNewPreRegistrationConfiguration,
    updatePreRegistrationConfiguration,
    deletePreRegistrationConfiguration,
   
} from "helpers/pre-registration-configurations/pre_registration_configurations_backend_helper";
import { toast } from "react-toastify";

function* fetchPreRegistrationConfigurations() {
    try {
        const response = yield call(getPreRegistrationConfigurations)
        yield put(getPreRegistrationConfigurationsSuccess(response))
    } catch (error) {
        yield put(getPreRegistrationConfigurationsFail(error))
    }
}

function* onAddNewPreRegistrationConfiguration({ payload }) {
    try {

        
        const response = yield call(addNewPreRegistrationConfiguration, payload)

        console.log("RESPONSE:", response);
        yield put(addPreRegistrationConfigurationSuccess(response.preRegistrationConfigurations))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addPreRegistrationConfigurationFail(error))
        toast.error(error.response?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdatePreRegistrationConfiguration({ payload: data }) {
    try {
        const response = yield call(updatePreRegistrationConfiguration, data)
        yield put(updatePreRegistrationConfigurationSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updatePreRegistrationConfigurationFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdatePreRegistrationConfiguration({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updatePreRegistrationConfiguration, payload)
        yield put(updatePreRegistrationConfigurationSuccess(response.preRegistrationConfiguration))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updatePreRegistrationConfigurationFail(error))
        toast.error(error.response?.message, { autoClose: 2000 });
    }
}

function* onDeletePreRegistrationConfiguration({ payload: data }) {

    try {
        const response = yield call(deletePreRegistrationConfiguration, data)
        yield put(deletePreRegistrationConfigurationSuccess(response.branch_id))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deletePreRegistrationConfigurationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* preRegistrationConfigurationSaga() {
    yield takeEvery(GET_PRE_REGISTRATION_CONFIGURATIONS, fetchPreRegistrationConfigurations)
    yield takeEvery(ADD_NEW_PRE_REGISTRATION_CONFIGURATION, onAddNewPreRegistrationConfiguration)
    yield takeEvery(UPDATE_PRE_REGISTRATION_CONFIGURATION, onUpdatePreRegistrationConfiguration)
    yield takeEvery(DELETE_PRE_REGISTRATION_CONFIGURATION, onDeletePreRegistrationConfiguration)
}

export default preRegistrationConfigurationSaga;